"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "marigliano": {
    "58aaa55c": [{
      "hkey": "a848bb48",
      "slug": "marigliano",
      "name": "Marigliano",
      "primary": true,
      "skipSearch": false
    }],
    "casaferro": [{
      "hkey": "a848bb48",
      "slug": "marigliano",
      "name": "Marigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "77c7c296": [{
      "hkey": "a848bb48",
      "slug": "marigliano",
      "name": "Marigliano",
      "primary": true,
      "skipSearch": false
    }],
    "faibano": [{
      "hkey": "a848bb48",
      "slug": "marigliano",
      "name": "Marigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "20a7ff2b": [{
      "hkey": "a848bb48",
      "slug": "marigliano",
      "name": "Marigliano",
      "primary": true,
      "skipSearch": false
    }],
    "lausdomini": [{
      "hkey": "a848bb48",
      "slug": "marigliano",
      "name": "Marigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6e9e9787": [{
      "hkey": "a848bb48",
      "slug": "marigliano",
      "name": "Marigliano",
      "primary": true,
      "skipSearch": false
    }],
    "miuli": [{
      "hkey": "a848bb48",
      "slug": "marigliano",
      "name": "Marigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "adc98dc1": [{
      "hkey": "a848bb48",
      "slug": "marigliano",
      "name": "Marigliano",
      "primary": true,
      "skipSearch": false
    }],
    "pontecitra": [{
      "hkey": "a848bb48",
      "slug": "marigliano",
      "name": "Marigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6690147b": [{
      "hkey": "a848bb48",
      "slug": "marigliano",
      "name": "Marigliano",
      "primary": true,
      "skipSearch": false
    }],
    "san-nicola": [{
      "hkey": "a848bb48",
      "slug": "marigliano",
      "name": "Marigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;